export interface RevalidationConfig {
  keys: string[];
  timestamp: number;
}

class RevalidationService {
  private revalidationMap = new Map<string, number>();

  setRevalidationTimestamp(keys: string[], timestamp = Date.now()) {
    keys.forEach((key) => {
      this.revalidationMap.set(key, timestamp);
    });
  }

  shouldRevalidate(key: string, cacheTimestamp: number): boolean {
    const revalidationTimestamp = this.revalidationMap.get(key);
    return revalidationTimestamp ? cacheTimestamp < revalidationTimestamp : false;
  }

  clearRevalidation(keys: string[]) {
    keys.forEach((key) => {
      this.revalidationMap.delete(key);
    });
  }
}

export const revalidationService = new RevalidationService();
